import Imprint from './Imprint'
import withHeader from 'hocs/withHeader'

export default withHeader(Imprint)
